module.exports = [
  require('./cadaver_collector'),
  require('./canoloth'),
  require('./choker'),
  require('./corpse_flower'),
]
